import React from 'react'
import { COLORS } from '@btime/constants'
import { find, map, prop } from 'ramda'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader, { useServiceOrder } from '../_load/ServiceOrderLoader'
import PdfOptionsFormHandler from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import Preview from '../../../../components/pdf/Preview'
import View from '../../../../components/pdf/View'
import Text, { Bold } from '../../../../components/pdf/Text'
import Separator from '../../../../components/pdf/Separator'
import Image from '../../../../components/pdf/Image'
import Page from '../../../../components/pdf/Page'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { findReplyByQuestionId, toCurrency } from '../_helpers/pdfHelpers'
import { Justify } from '../_shared/Justify'

const Content = ({ repliesParent }) => {
  const { replies: repliesMain } = useServiceOrder()
  const replies = !!repliesParent ? repliesParent : repliesMain

  const listReplieReference = map(prop('reference'))(prop('value')(find(it => it.questionId === 1711)(replies)))

  const implantation = findReplyByQuestionId(replies, 1687)?.value || findReplyByQuestionId(replies, 1688)?.value
  const numberOfInstallment = findReplyByQuestionId(replies, 1689)?.value
  const fullPayment = findReplyByQuestionId(replies, 1688)?.value

  const typeOfBillingName = findReplyByQuestionId(replies, 1690)?.value?.name || ''

  const monthValue =
    findReplyByQuestionId(replies, 1746)?.value ||
    findReplyByQuestionId(replies, 1747)?.value ||
    findReplyByQuestionId(replies, 1748)?.value ||
    findReplyByQuestionId(replies, 1749)?.value ||
    findReplyByQuestionId(replies, 1750)?.value

  const quantityPerValue =
    findReplyByQuestionId(replies, 1691)?.value ||
    findReplyByQuestionId(replies, 1695)?.value ||
    findReplyByQuestionId(replies, 1699)?.value ||
    findReplyByQuestionId(replies, 1703)?.value ||
    findReplyByQuestionId(replies, 1708)?.value

  const unitOnPackValue =
    findReplyByQuestionId(replies, 1692)?.value ||
    findReplyByQuestionId(replies, 1696)?.value ||
    findReplyByQuestionId(replies, 1700)?.value ||
    findReplyByQuestionId(replies, 1704)?.value ||
    findReplyByQuestionId(replies, 1709)?.value

  const addValue =
    findReplyByQuestionId(replies, 1693)?.value ||
    findReplyByQuestionId(replies, 1697)?.value ||
    findReplyByQuestionId(replies, 1701)?.value ||
    findReplyByQuestionId(replies, 1705)?.value ||
    findReplyByQuestionId(replies, 1710)?.value

  const showAdicionalService = findReplyByQuestionId(replies, 1786)?.value

  const partService = findReplyByQuestionId(replies, 1782)?.value

  const partServiceAutomationRecurrence =
    findReplyByQuestionId(replies, 1784)?.value || findReplyByQuestionId(replies, 1785)?.value

  return (
    <Text bold size="medium">
      <View id="1" pageBreakAfter>
        <Header />
        <Text size="medium" bold>
          Objetivo
        </Text>
        <br />
        <Text size="medium" align="justify">
          À medida que o mercado continua a evoluir, impulsionado pelo aumento da necessidade de eficiência e pela maior
          acessibilidade de tecnologias avançadas, propomos a plataforma Btime, uma solução de gestão empresarial SaaS
          robusta e abrangente.
        </Text>
        <br />
        <Text size="medium" align="justify">
          Priorizamos a entrega de uma experiência de usabilidade intuitiva para gestores e administradores, com o
          objetivo central de assegurar um ambiente operacional excepcional para todos os usuários. Nossa plataforma é
          projetada para aprimorar a eficiência operacional, garantindo um ambiente seguro, confortável e bem-mantido
          para todos os usuários das instalações.
        </Text>
        <br />
        <Text size="medium" bold>
          Objetivo da Solução:
        </Text>
        <br />
        <Text size="medium" align="justify">
          Fornecer uma plataforma integrada projetada para otimizar os processos operacionais e administrativos de
          empresas de diversos setores. Esta solução abrange uma ampla gama de funcionalidades, incluindo gestão de
          tarefas, monitoramento de atividades, controle de acesso e sistemas de gerenciamento de informações,
          oferecendo uma administração completa do negócio.
        </Text>
        <br />
        <Text size="medium" bold>
          Características da Plataforma:
        </Text>
        <ul>
          <li>
            <Text size="medium" bold>
              Gestão de Equipes Eficiente:
            </Text>
            <ul>
              <li>
                <Text size="medium" align="justify">
                  Substituição de controles manuais
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Facilitação da comunicação
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Eliminação de erros
                </Text>
              </li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Gestão Proativa de Não Conformidades:
            </Text>
            <ul>
              <li>
                <Text size="medium" align="justify">
                  Registro e acompanhamento contínuo
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Identificação e correção precoce
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Melhoria da eficácia operacional
                </Text>
              </li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Padronização de Rotinas:
            </Text>
            <ul>
              <li>
                <Text size="medium" align="justify">
                  Uniformidade de procedimentos
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Rotinas claras
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Facilitação da gestão em diferentes ambientes
                </Text>
              </li>
            </ul>
          </li>

          <li>
            <Text size="medium" bold>
              Checklists Digitais e Qualidade no Serviço:
            </Text>
            <ul>
              <li>
                <Text size="medium" align="justify">
                  Transição para o digital
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Conclusão precisa e eficiente
                </Text>
              </li>
              <li>
                <Text size="medium" align="justify">
                  Serviços de alta qualidade
                </Text>
              </li>
            </ul>
          </li>
        </ul>
      </View>

      <View id="2" pageBreakAfter>
        <Separator weight={10} />
        <Header />
        <Text size="medium" bold>
          Benefícios Adicionais:
        </Text>
        <ul>
          <li>
            <Text size="medium" align="justify">
              Funcionalidade Offline
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Integração com outras plataformas
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Medição de Desempenho e Relatórios Detalhados
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Dashboard de Gestão à Vista
            </Text>
          </li>
        </ul>
        <Text size="medium" bold>
          Resumo Investimento Proposta Comercial
        </Text>
        <ul>
          <li>
            Implantação - {toCurrency(implantation)} {!fullPayment && `(${numberOfInstallment}x)`}
          </li>
          <li>Mensal - {toCurrency(monthValue)} </li>
        </ul>
        <br />
        <Text size="medium" bold>
          Investimento - Implantação
        </Text>
        <br />
        <Text size="medium" align="justify">
          💡O que é Implantação/Setup? Consiste na etapa de configuração, estruturação e digitalização do ambiente do
          cliente. Isso inclui na alocação de analistas funcionais de nosso time para fazer toda a tradução do processo
          atual do cliente para o Workspace na Btime. Dessa forma, a implantação engloba as fases de mapeamento,
          digitalização, cadastro de dados, automatização e validação do processo.
        </Text>
        <br />
        <ul>
          <li>
            <Text size="medium" bold>
              Implantação - {toCurrency(implantation)}
            </Text>
          </li>
        </ul>
        <br />
        <Text size="medium" bold>
          Valor do investimento
        </Text>
        <br />
        <Text bold size="h5" align="left">
          Itens
        </Text>
        <ul>
          <li>
            <Text size="medium" align="justify">
              Prazo para implantação
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Horas de pontos de contato com a equipe durante a trilha de implantação (divididas nos itens abaixo)
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Reunião de Kick-Off{' '}
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Reunião de Rollout
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Auto-implantação
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Configuração do ambiente pelos implementadores
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Envio dos materiais de apoio padrões para auto implantação
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Reunião de validação
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Consultoria e treinamento
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Envio dos materiais de treinamentos personalizados
            </Text>
          </li>
        </ul>
      </View>
      <View id="3" pageBreakAfter>
        <Header />
        <ul>
          <li>
            <Text size="medium" align="justify">
              Raio X após o rollout
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Ponto de contato: WhatsApp dedicado
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Ponto de contato: suporte
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Suporte no Chat na Btime em horário comercial
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Suporte em Grupo Whatsapp
            </Text>
          </li>
          <li>
            <Text size="medium" align="justify">
              Gerente de Sucesso Dedicado
            </Text>
          </li>
        </ul>
        <Text size="medium" bold>
          Mensal - {toCurrency(monthValue)}
        </Text>
        <ul>
          <li>Preço por {typeOfBillingName}</li>
        </ul>
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text bold size="medium">
                Quantidade por mês
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor mensal
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor Unitario
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Valor Adicional
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">{quantityPerValue}</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(monthValue)}</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(unitOnPackValue)} </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(addValue)}</Text>
            </TableCol>
          </TableRow>
        </Table>
        <br />
        <Text size="medium" bold>
          Plano SMB
        </Text>
        <br />
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text bold size="medium"></Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Funcionalidade
              </Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium"></Text>
            </TableCol>
            <TableCol>
              <Text bold size="medium">
                Observação:
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Investimento</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Valor Mensal</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">{toCurrency(monthValue)}</Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Log de Atividades (30 dias)</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396899086558350') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Aplicativo Android e IOS</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139690037741046') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Aplicativo online e offline</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396906999176374') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Exportação Excel</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396907629638075') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Uso</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Exportação PDF</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396908035299006') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Checklists customizáveis</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396908652215424') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Usuarios</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396909168180118') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Locais</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396909555886202') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Atividades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396909967229073') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Não conformidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396910514542621') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Qrcodes</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396911429918425') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Funcionalidades</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Formulários</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396911957859909') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Workflow automatizado</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396912399372703') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações D4sign</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396912888873691') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396912888873691') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
        <br />
        <br />
      </View>
      <View id="4" pageBreakAfter>
        <Header />
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações WhatsApp</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396913341546008') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396913341546008') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações Slack</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691366473018') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691366473018') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações SMS</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691398477394') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691398477394') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Automações</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396914329770842') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396914692730757') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações customizáveis</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396914692730757') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396914692730757') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Integrações Recorrentes</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396915137964108') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Automação e Integração</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Criação de cards em massa importando planilhas</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396915685556411') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Acesso à Base de Conhecimento Btime</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396916339678294') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Suporte no Chat na Btime em horário comercial</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396916756749284') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Suporte em Grupo Whatsapp</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691712142123') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Treinamento e Suporte</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Gerente de Sucesso Dedicado</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691712142123') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139691712142123') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">Privacidade e Segurança</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Single Sign-On</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396920363496532') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Visualizações e Relatórios</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Visualização Kanban</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396921105990018') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>

          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Dashboards Customizados</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396921879189625') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396921879189625') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </View>
      <View id="5" pageBreakAfter>
        <Header />
        <Table width="90%" center>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Mapa</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396923314874413') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396923314874413') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Segmentação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396923729170555') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396923729170555') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Data Lake</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396924051050500') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396924051050500') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Sustentação</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396924460825000') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396924460825000') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Gerador de documentos customizados</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139692486548915') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R117139692486548915') ? <></> : <>Contratação à parte</>}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol>
              <Text size="medium">Extensões</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">Gerador de Documentos nativos</Text>
            </TableCol>
            <TableCol>
              <Text size="medium">
                {(listReplieReference || []).includes('R1171396925264022368') ? <>✅</> : <>❌</>}
              </Text>
            </TableCol>
            <TableCol>
              <Text size="medium"></Text>
            </TableCol>
          </TableRow>
        </Table>
      </View>
      <AdicionalInformation showAdicionalService={showAdicionalService} />
    </Text>
  )
}

const AdicionalInformation = ({ showAdicionalService }) =>
  showAdicionalService ? (
    <View id="6" pageBreakAfter>
      <Header />
      <Text size="medium" bold>
        Serviços Adicionais
      </Text>
      <ul>
        <li>
          <Text size="medium" align="justify">
            Valor Hora Desenvolvimento: R$150,00
          </Text>
        </li>
        <li>
          <Text size="medium" align="justify">
            Valor hora Sustentação: R$150,00
          </Text>
        </li>
      </ul>
      <Separator weight={10} />
      <Text size="medium" bold>
        Pacotes de Horas Anuais de Sustentação
      </Text>
      <br />
      <Table width="80%" center>
        <TableRow>
          <TableCol>
            <Text bold size="medium">
              Pacote de Horas
            </Text>
          </TableCol>
          <TableCol>
            <Text bold size="medium">
              Valor da Hora
            </Text>
          </TableCol>
          <TableCol>
            <Text bold size="medium">
              Valor do Pacote (Upfront)
            </Text>
          </TableCol>
          <TableCol>
            <Text bold size="medium">
              Valor do Pacote (Parcelado)
            </Text>
          </TableCol>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="medium">120 horas</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$ 150,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$16.200,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$18.000,00</Text>
          </TableCol>
        </TableRow>

        <TableRow>
          <TableCol>
            <Text size="medium">150 horas</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$ 140,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$19.620,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$21.800,00</Text>
          </TableCol>
        </TableRow>

        <TableRow>
          <TableCol>
            <Text size="medium">180 horas</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$ 130,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$21.060,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$23.400,00</Text>
          </TableCol>
        </TableRow>

        <TableRow>
          <TableCol>
            <Text size="medium">200 horas</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$ 120,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$21.600,00</Text>
          </TableCol>
          <TableCol>
            <Text size="medium">R$24.000,00</Text>
          </TableCol>
        </TableRow>
      </Table>
      <ul>
        <ul>
          <li>Desconto de 10% aplicado no pagamento Upfront</li>
        </ul>
      </ul>
      <Text size="medium" align="justify">
        Cada linha representa um pacote diferente, começando com um pacote de 120 horas e chegando até 200 horas. O
        valor da hora diminui à medida que o número de horas no pacote aumenta, sugerindo um desconto por volume. O
        pagamento antecipado (upfront) também parece oferecer um desconto adicional de 10% sobre o preço total.
      </Text>
      <br />
      <Text size="medium" bold>
        Dashboard customizado - Power BI
      </Text>
      <ul>
        <li>
          <Text size="medium" align="justify">
            Envolve o custo mensal de manutenção + custo de Setup
          </Text>
          <ul>
            <li>
              <Text size="medium" align="justify">
                Desconto de 10% aplicado no pagamento Upfront
              </Text>
            </li>
          </ul>
        </li>
      </ul>
      <Image src="/pdfs/interno/dash-customizado-exemplo.png" maxWidth={480} />
      <Text size="medium" bold>
        Lake
      </Text>
      <ul>
        <li>
          <Text size="medium" align="justify">
            Setup + documentação + horas = sob consulta
          </Text>
        </li>
      </ul>
    </View>
  ) : (
    <></>
  )

const Header = () => (
  <>
    <Grid justify="left" align="left">
      <Image src="/btime-logo-roxo.png" maxWidth={150} ignoreFixedSize />
    </Grid>
    <Separator weight={10} />
  </>
)
const TemplateInternoPropostaSmbPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.dark1 }}>
          <PageHeader templateId={parseInt(templateId)} />
          <Grid align="stretch">
            <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 5.3rem)">
              <Preview>
                <Page>
                  <Content />
                </Page>
              </Preview>
            </Col>
          </Grid>
        </PdfOptionsFormHandler>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export const PropostaSmb = Content

export default TemplateInternoPropostaSmbPdfPage
